import React, { useCallback } from 'react';
import { BacklogInsightsButton } from '@atlassian/jira-insights-backlog-button';
import { useIsCurrentBrowserSupported } from '@atlassian/jira-insights-common';
import { BacklogInsightsNudgeAsync } from '@atlassian/jira-software-onboarding-nudges--next/src/async';
import { INSIGHTS_PANEL } from '../../../../model/panels/constants';
import { useIsCMPBacklog } from '../../../../state/state-hooks/capabilities';
import type { InsightsButtonProps } from './types';

export const InsightsButton = ({
	onToggle,
	isInsightsPanelOpen,
	boardId,
	edition = null,
}: InsightsButtonProps) => {
	const isSupported = useIsCurrentBrowserSupported();
	const isCMPBacklog = useIsCMPBacklog();

	const onToggleHandler = useCallback(() => {
		onToggle(INSIGHTS_PANEL);
	}, [onToggle]);

	if (!isSupported) {
		return null;
	}

	if (!edition) {
		return null;
	}

	return !__SERVER__ ? (
		<BacklogInsightsNudgeAsync>
			<BacklogInsightsButton
				isSimplifiedProject={!isCMPBacklog}
				isOpen={isInsightsPanelOpen}
				isCompact={false}
				boardId={Number(boardId)}
				edition={edition}
				onToggle={onToggleHandler}
			/>
		</BacklogInsightsNudgeAsync>
	) : (
		<BacklogInsightsButton
			isSimplifiedProject={!isCMPBacklog}
			isOpen={isInsightsPanelOpen}
			isCompact={false}
			boardId={Number(boardId)}
			edition={edition}
			onToggle={onToggleHandler}
		/>
	);
};
